module.exports = {"433173002":"湖南永顺经济开发地区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433173.json
// module id = 2070
// module chunks = 0